module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-captcha",
    attrs: {
      "id": "captchaBox"
    }
  }, [(_vm.capType == 1) ? _c('div', [_c('urs-input', {
    ref: "capInput",
    attrs: {
      "size": "small",
      "placeholder": "请输入图片验证码"
    },
    on: {
      "input": _vm.imgcapInput
    }
  }, [_c('div', {
    staticClass: "u-img",
    on: {
      "click": function($event) {
        _vm.initCap()
      }
    },
    slot: "button"
  }, [_c('img', {
    staticClass: "cap-img",
    attrs: {
      "src": _vm.imgCapUrl,
      "alt": "点击获取"
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.capType == 4 || _vm.capType == 5),
      expression: "capType==4||capType==5"
    }],
    staticClass: "u-scap"
  }, [_c('div', {
    ref: "sCaptcha",
    staticClass: "Scaptcha",
    attrs: {
      "id": "Scaptcha"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a44fb5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Capture.vue
// module id = 510
// module chunks = 1